import { render, staticRenderFns } from "./lists.vue?vue&type=template&id=12f58d9e&scoped=true"
import script from "./lists.vue?vue&type=script&lang=js"
export * from "./lists.vue?vue&type=script&lang=js"
import style0 from "./lists.vue?vue&type=style&index=0&id=12f58d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f58d9e",
  null
  
)

export default component.exports